<template>
	<section class="contact-info-block">
		<div class="contact-info-block container">
			<div class="contact-info-block__left">
				<h2 class="contact-info-block__title" v-if="title" v-html="title"></h2>

				<div class="contact-info-block__offices">
					<div
						v-for="(office, idx) in offices"
						:key="idx"
						class="contact-info-block__office"
					>
						<div class="contact-info-block__office-title">
							{{ office.office_title }}
						</div>
						<div
							class="contact-info-block__office-address"
							v-html="office.office_address"
						></div>
						<div class="contact-info-block__office-contacts">
							<a
								v-if="office.office_phone"
								:href="`tel:${(office.office_phone || '').replace(/\s+/g, '')}`"
								>{{ 'T: ' + office.office_phone }}</a
							>

							<a
								v-if="office.office_tollfree"
								:href="`tel:${(office.office_tollfree || '').replace(
									/\s+/g,
									'',
								)}`"
								>{{ 'Toll Free: ' + office.office_tollfree }}</a
							>

							<a
								v-if="office.office_fax"
								:href="`tel:${(office.office_fax || '').replace(/\s+/g, '')}`"
								>{{ 'F: ' + office.office_fax }}</a
							>
						</div>

						<div v-if="office.office_email">
							<a :href="`mailto:${office.office_email}`"><span>Email</span></a>
						</div>
					</div>
				</div>
			</div>
			<div class="contact-info-block__right">
				<slot name="form"></slot>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'ContactInfo',
	props: {
		title: { type: String, default: '' },
		offices: { type: Array, default: () => [] },
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.contact-info-block {
	background: transparent;
	padding-top: 24px;
	padding-bottom: 24px;

	@media (max-width: $mobile-xl) {
		row-gap: 32px;
	}

	&__container {
		display: flex;
		flex-wrap: wrap;
		max-width: 1400px;
		margin: 0 auto;
		gap: 40px;
		align-items: flex-start;
		justify-content: space-between;
	}

	&__left {
		display: grid;
		grid-template-rows: auto auto;
		gap: 40px;
	}

	&__title {
		color: var(--fpe-blue);
		margin-bottom: 0;
		margin-top: 0;
		padding-right: 100px;
	}

	&__offices {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 32px;
	}

	&__office {
		background: var(--fpe-mid-grey);
		border-radius: 14px;
		padding: 48px 24px;
		color: var(--fpe-blue);
		font-size: 1.1rem;
		box-shadow: none;
		display: flex;
		flex-direction: column;
		gap: 24px;
		min-width: 260px;

		> div {
			position: relative;

			a {
				position: relative;
				text-decoration: none;
				display: flex;
				font: normal normal 300 14px/18px var(--primary-font-family);
				color: var(--fpe-blue);
				align-items: center;

				&:hover {
					text-decoration: underline;
					border-bottom: 1px solid var(--fpe-light-brown);
					transition: 0.2s ease all;
				}

				&[href^='mailto:'] {
					padding: 0;
					border-right: 0;
					border: none;
					position: relative;
					display: flex;
					align-items: center;
					gap: 12px;
					border-bottom: 1px solid var(--fpe-blue);
					font: normal normal 300 14px/18px var(--primary-font-family);
					color: var(--fpe-blue);
					text-decoration: none;

					span {
						transition: 0.2s ease all;
						font: normal normal 300 14px/18px var(--primary-font-family);
						position: relative;
						left: 0;
					}

					&:hover {
						border-bottom: 1px solid var(--fpe-light-brown);
						transition: 0.2s ease all;

						span {
							position: relative;
							left: -21px;
							transition: 0.2s ease all;
							color: var(--fpe-light-brown);
						}

						&::before {
							opacity: 0;
							transition: 0.2s ease all;
							transform: translateX(-100%);
							visibility: hidden;
						}

						&::after {
							opacity: 1;
							transition: 0.2s ease all;
							transform: translateX(-21px);
							visibility: visible;
						}
					}

					&::before {
						content: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuODM0Njk3IDEwTDAgOS4xNzg5OEw2Ljg1NzYxIDIuMjgyNDNMMi4zMDc2OSAxLjIxNTExTDIuNTY5NTYgMEw4LjUxMDY0IDEuNDYxNDFMMTAgNy41MDQxMUw4Ljc3MjUgNy43ODMyNUw3LjY5MjMxIDMuMTE5ODdMMC44MzQ2OTcgMTBaIiBmaWxsPSIjNTM2MjhCIi8+Cjwvc3ZnPgo=');
						/* width: 6.11px;
                height: 6.09px;
                background: var(--cobalt); */
						opacity: 1;
						transition: 0.2s ease all;
						transform: translateX(0);
						visibility: visible;
					}

					&::after {
						content: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuODM0Njk3IDEwTDAgOS4xNzg5OEw2Ljg1NzYxIDIuMjgyNDNMMi4zMDc2OSAxLjIxNTExTDIuNTY5NTYgMEw4LjUxMDY0IDEuNDYxNDFMMTAgNy41MDQxMUw4Ljc3MjUgNy43ODMyNUw3LjY5MjMxIDMuMTE5ODdMMC44MzQ2OTcgMTBaIiBmaWxsPSIjOWQ4ODc5Ii8+Cjwvc3ZnPgo=');
						/* width: 6.11px;
                height: 6.09px;
                background: var(--cobalt); */
						opacity: 0;
						transition: 0.2s ease all;
						transform: translateX(0);
						visibility: hidden;
					}
				}
			}
		}
	}

	&__office-title {
		font: normal normal 300 18px/24px var(--primary-font-family);
		color: var(--fpe-blue);
	}

	&__office-address {
		color: var(--fpe-blue);
	}

	&__office-contacts {
		display: flex;
		flex-direction: column;
		gap: 8px;
		margin-bottom: 24px;
	}

	&__left {
		grid-column: 1 / span 6;

		@media (max-width: $mobile-xl) {
			grid-column: 1 / span 4;
		}
	}

	&__right {
		grid-column: 7 / span 6;
		display: flex;
		flex-direction: column;
		align-items: stretch;
		box-sizing: border-box;

		@media (max-width: $mobile-xl) {
			grid-column: 1 / span 4;
		}
	}

	@media (max-width: 900px) {
		&__container {
			flex-direction: column;
			gap: 32px;
		}
		&__left,
		&__right {
			max-width: 100%;
			min-width: 0;
		}
		&__offices {
			grid-template-columns: 1fr;
		}
	}
}
</style> 


// WEBPACK FOOTER //
// resources/assets/scripts/vue/ContactInfo.vue